module.exports = __webpack_public_path__ + "img/5.f7cb1ef0.png";